/* eslint-disable object-curly-newline */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable import/no-unresolved */
import './login-form.scss';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import * as yup from 'yup';
import { Else, If, Then, When } from 'react-if';
import TextField from '../../form-fields/text-field';
import PasswordField from '../../form-fields/password-field';
import CheckboxField from '../../form-fields/checkbox-field';
import PrimaryButton from '../../buttons/primary-button/primary-button';
import {
  YUP_EMAIL_SCHEMA,
  YUP_PASSWORD_SCHEMA,
} from '../../../../utilities/form';

const schema = yup
  .object({
    email: YUP_EMAIL_SCHEMA,
    password: YUP_PASSWORD_SCHEMA,
    rememberUser: yup.boolean(),
  })
  .required();

const LoginForm = ({
  onSubmit,
  isLoading,
  error,
  onVerify,
  emailVerificationResent,
  showAccountVerifiedMessage,
  showResetMessage,
}) => {
  const methods = useForm({
    resolver: yupResolver(schema),
    mode: 'all',
    defaultValues: {
      email: '',
      password: '',
      rememberUser: false,
    },
  });

  return (
    <div className="login-form">
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <div className="login-form__content">
            <If condition={showAccountVerifiedMessage}>
              <Then>
                <h2 className="login-form__title">Account Verified!</h2>
                <p className="login-form__account-verified">
                  Your account is all set, sign in below to start exploring your
                  account.
                </p>
              </Then>
              <Else>
                <h2 className="login-form__title">Sign in</h2>
              </Else>
            </If>

            <When condition={emailVerificationResent}>
              <div className="login-form__alert">
                We have sent another verification code to
                <span>{methods.getValues().email}</span>. It may take a few
                minutes.
              </div>
            </When>

            <When condition={showResetMessage}>
              <div className="login-form__alert">
                Reset password successful!
              </div>
            </When>

            <When condition={error?.name === 'NotAuthorizedException'}>
              <div className="login-form__error">{error?.message}</div>
            </When>

            <When
              condition={
                error?.name === 'UserNotConfirmedException' &&
                !emailVerificationResent
              }
            >
              <div className="login-form__error">
                <p className="login-form__error__vn__title">
                  VERIFICATION NEEDED
                </p>
                <p className="login-form__error__vn__description">
                  We’ve sent a verification email to
                  <span>{methods.getValues().email}</span>. Once you’ve verified
                  your email you’ll be able to sign in. If you didn't receive an
                  email,
                  <button
                    type="button"
                    onClick={() => onVerify(methods.getValues().email)}
                  >
                    click here
                  </button>
                  to resend the verification email.
                </p>
              </div>
            </When>

            <div className="login-form__section">
              <TextField type="email" name="email" label="Email" required />
              <PasswordField name="password" label="Password" />

              <div className="login-form__actions">
                <CheckboxField label="Remember me" name="rememberUser" />
                <Link
                  className="login-form__actions__reset"
                  to="/reset-password"
                >
                  Forgot password?
                </Link>
              </div>
            </div>

            <div className="login-form__submit">
              <PrimaryButton title="Sign in" isLoading={isLoading} fullWidth />
            </div>

            <p className="login-form__signup">
              <span>Don't have an account?</span>
              <Link to="/signup">Create one</Link>
            </p>
          </div>
        </form>
      </FormProvider>
    </div>
  );
};

export default LoginForm;
